// This is a general purpose store for settings any other global state or actions.
import ax from '@utils/axios'

import { defineStore } from 'pinia'

import { useUserStore } from '../users'
import { handleError } from '@utils/helpers'

export const useGeneralStore = defineStore('general', {
  state: () => {
    return {
      showGlobalLoadingIndicator: false,
      showLocalLoadingIndicator: false,
      selectedTags: [],
      availableTags: [],
      localDev: {
        database: 'local',
        // TODO:this should be replaced by /v2/devtools/impersonation-target response
        user_id: import.meta.env.MODE === 'development' ? 2 : null,
      },
      tinyMceApiKey: import.meta.env.VITE_TINYMCE_KEY || 'k9y4nntc9ti7fn0ei6p2e506bpspyjqwfavbm0au380mp2bk',
    }
  },
  getters: {
    isAppDataLoaded() {
      // This is to check if the necessary data is loaded before rendering the pages/components
      // to the DOM. Otherwise, the app breaks when the api calls don't come back in time.
      const userStore = useUserStore()

      // Makes sure the vendor object is populated if the user is a vendor or the
      // partner object is populated if they are a partner.
      if (userStore.partnerId && Object.keys(userStore.partner).length > 0) {
        return true
      } else if (userStore.vendorId && Object.keys(userStore.vendor).length > 0) {
        return true
      }

      return false
    },
    isLocalDev() {
      return import.meta.env.MODE === 'development'
    },
  },
  actions: {
    async fetchAvailableTags() {
      const tags = await ax.get('/v2/partner-tags')
      this.availableTags = [ ...tags.data ]
    },
    async fetchAvailablePartnerTags() {
      const userStore = useUserStore()
      const partnerId = userStore.partnerId

      if(!partnerId) {
        return
      }

      try {
        const { data: vendorPartnerAccocs } = await ax.get(`v2/partners/${partnerId}/vendors`)
        this.availableTags = vendorPartnerAccocs.map(vpAssoc => ({
          id: vpAssoc.vendor.id,
          text: vpAssoc.vendor.name,
        }))
      } catch (error) {
        handleError(error)
      }
    },
    getTagIds() {
      return this.selectedTags.filter(tag => tag.id !== undefined).map(tag => tag.id).join(',')
    }
  }
})
